import { ChemistryQuiz } from '@efdigital/ll-xceed-v2/components/coaching/coachee/chemistry-quiz.gts';
import type { CoachingCoacheeCohortCoachesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/coaches';
import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';

interface CoachingCoacheeCohortCoachesSignature {
  Args: {
    model: CoachingCoacheeCohortCoachesModel;
    controller: unknown;
  };
}

function showQuizInput(model: CoachingCoacheeCohortCoachesModel): boolean {
  return !!(model.chemistryQuiz?.quiz && model.chemistryQuiz?.answer?.draft);
}

export default <template>
  {{#if (showQuizInput @model)}}
    <div class="container my-3">
      {{#if @model.chemistryQuiz}}
        <div class="p-lg-5">
          <ChemistryQuiz
            @quiz={{@model.chemistryQuiz.quiz}}
            @answer={{@model.chemistryQuiz.answer}}
            @initialMode="input"
          />
        </div>
      {{/if}}
    </div>
  {{else}}
    <div class="container my-3">
      <ul
        class="nav nav-pills nav-fill coaching-dashboard-coach-tabs bg-body rounded-pill p-1 shadow-sm w-100 flex-nowrap"
        role="tablist"
      >
        <li class="nav-item" role="presentation">
          <LinkTo
            @route="coaching.coachee.cohort.coaches.index"
            type="button"
            class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
            role="tab"
          >
            <span class="d-sm-none">Pool</span>
            <span class="d-none d-sm-inline">Coaching Pool</span>
          </LinkTo>
        </li>
        <li class="nav-item" role="presentation">
          <LinkTo
            @route="coaching.coachee.cohort.coaches.shortlist"
            class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
            role="tab"
          >
            <span class="d-sm-none">Shortlist</span>
            <span class="d-none d-sm-inline">Your Shortlist</span>
            <span
              class="border px-3 rounded-pill"
            >{{@model.planner.chemistryAndChosenPartnerships.length}}</span>
          </LinkTo>
        </li>
        <li class="nav-item" role="presentation">
          <LinkTo
            @route="coaching.coachee.cohort.coaches.chosen"
            class="nav-link rounded-pill px-2 px-lg-4 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 gap-md-2 w-100"
            role="tab"
          >
            Your Coach
            <span
              class="border px-3 rounded-pill"
            >{{@model.planner.chosenPartnerships.length}}</span>
          </LinkTo>
        </li>
      </ul>
    </div>

    {{outlet}}
  {{/if}}
</template> satisfies TOC<CoachingCoacheeCohortCoachesSignature>;
